import { render, staticRenderFns } from "./injury-info.vue?vue&type=template&id=24e5d3d5&"
import script from "./injury-info.vue?vue&type=script&lang=js&"
export * from "./injury-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports